const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiDataModel.SCHEDULE)

export const apiOperationSchedule = {
	updateOrderScheduleOperations: async (
		selectedDay: EOrderScheduleDays,
		payload: IOrderScheduleDeadlineModel,
	): Promise<IOrderScheduleOperationModel[]> => {
		const { data } = await apiCommon<IOrderScheduleOperation[]>(`${groupPrefix}/${selectedDay}`, {
			method: 'PATCH',
			body: OrderScheduleOperationPayloadToBody(payload),
		})

		return data.map(d => OrderScheduleOperation(d))
	},
}
